import { useCallback, useEffect, useRef } from 'react'
import { useField, useFormikContext } from 'formik'
import { FormState } from '@user/components/ClosedLostReasonsDialog/formConfig'

export function useFormFields() {
  const { setFieldValue } = useFormikContext<FormState>()

  const customReasonRef = useRef<HTMLInputElement>()

  const [reasonField] = useField<string>('reasonId')
  const [customReasonField] = useField<string>('customReason')

  const onFocusCustomReason = useCallback(() => {
    setFieldValue('reasonId', '0')
  }, [setFieldValue])
  const customReasonHelperText = `Max character limit is 50. Your current count is ${
    customReasonField.value?.length || 0
  }/50`

  useEffect(() => {
    if (reasonField.value !== '0') {
      setFieldValue('customReason', '')
    } else {
      customReasonRef.current?.focus()
    }
  }, [reasonField.value, setFieldValue])

  return {
    reasonField,
    customReasonRef,
    customReasonField,
    onFocusCustomReason,
    customReasonHelperText,
  }
}
